import type { GetNotificationResponse } from "@/openapi/generated";
import {
  buildMakeupPortalLink,
  extractAttendanceLogIdFromNotificationText,
} from "./makeupPortalLinks";

const MAKEUP_NOTIFICATION_PATTERN = /makeup/i;
const ABSENT_NOTIFICATION_PATTERN =
  /\b(absent|missed\s+(?:a\s+)?class|did\s+not\s+attend|wasn't\s+present)\b/i;

function notificationHaystack(notification: GetNotificationResponse): string {
  return [notification.type, notification.title, notification.message]
    .filter(Boolean)
    .join(" ");
}

function isMakeupWorkflowNotification(haystack: string): boolean {
  return MAKEUP_NOTIFICATION_PATTERN.test(haystack);
}

function isAbsentAttendanceNotification(haystack: string): boolean {
  return ABSENT_NOTIFICATION_PATTERN.test(haystack);
}

/**
 * Returns a portal path when a notification is makeup-related or marks an absence
 * parents can request makeup for. Embeds `attendanceLogId` when present in copy.
 */
export function resolveNotificationMakeupLink(
  notification: GetNotificationResponse,
): string | null {
  const haystack = notificationHaystack(notification);
  const isMakeup = isMakeupWorkflowNotification(haystack);
  const isAbsent = isAbsentAttendanceNotification(haystack);

  if (!isMakeup && !isAbsent) {
    return null;
  }

  const attendanceLogId = extractAttendanceLogIdFromNotificationText(
    notification.type,
    notification.title,
    notification.message,
  );

  return buildMakeupPortalLink(attendanceLogId);
}
